import { createFileRoute } from '@tanstack/react-router'

import { RedeemableLiquidityPool } from '@/components/Redeem/LiquidityOverview'
import { withStaticTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/$id/liquidity')({
  component: RedeemableLiquidityPage,
  head: withStaticTitle('Liquidity Pool'),
})

function RedeemableLiquidityPage() {
  const { id } = Route.useParams()
  return <RedeemableLiquidityPool redeemableId={id} />
}
